import * as React from "react";

const SvgLegend = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7.66 7.634-2.166-3.75-2.165 3.75zm-.166 6.565v-4h-4v4zm-4 3.917a2 2 0 1 1 4 0 2 2 0 0 1-4 0m6-.917v2h12v-2zm0-6v2h12v-2zm0-6v2h12v-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLegend;
